export const STAGE_MESSAGE_ON_STUBBED_THREAD = 'STAGE_MESSAGE_ON_STUBBED_THREAD';
export const ADD_VISITOR_MESSAGE_TO_STUBBED_THREAD = 'ADD_VISITOR_MESSAGE_TO_STUBBED_THREAD';
export const RESET_STUBBED_THREAD = 'RESET_STUBBED_THREAD';